module.exports = __webpack_public_path__ + "fbad62c1435521fc4e5c3c106c742303.svg";